/* eslint-disable */
// Initialize Instana monitoring
export const initializeInstana = () => {
  if ( process.env.REACT_APP_INSTANA_REPORTING_URL && process.env.REACT_APP_INSTANA_KEY ) {
    // Initialize Instana monitoring object
    ( function ( s, t, a, n ) {
      s[t] || ( s[t] = a, n = s[a] = function () { n.q.push( arguments ); }, n.q = [], n.v = 2, n.l = 1 * new Date() );
    } )( window, 'InstanaEumObject', 'ineum' );

    // Configure Instana with environment variables
    window.ineum( 'reportingUrl', process.env.REACT_APP_INSTANA_REPORTING_URL );
    window.ineum( 'key', process.env.REACT_APP_INSTANA_KEY );
    window.ineum( 'trackSessions' );
  }
};
/* eslint-enable */
